import React, {useCallback, useEffect, useState} from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import config from "../../../../config";

import Translate from "../../../../components/Translate";
import {addNotification as addNotificationAction} from "../../../../services/notification/action";
import {updateUserData as updateUserDataAction} from "../../../../services/user/action";
import {changePassword as changePasswordApi,} from "../../../../services/user/api";
import "./index.css";
import {generalModalStyles} from "../../../../utils/General";
import Modal from '../../../../components-new/ui/Modal';
import SilverButton from "../../../../components-new/buttons/SilverButton";
import BlueButton from "../../../../components-new/buttons/BlueButton";
import Input from "../../../../components-new/form/Input";
import LockKeyholeIcon from "../../../../assets/icons/LockKeyholeIcon";
import './SettingsModal.css';

const SecurityModal = ({
                           user,
                           close,
                           isOpen,
                           onRequestClose,
                           addNotification,
                           updateUserData,
                       }) => {

    const [formData, setFormData] = useState({
        oldPassword: "",
        newPassword: "",
    });

    useEffect(() => {
        if (isOpen && user) {
            setFormData({
                oldPassword: "",
                newPassword: "",
            });
        }
    }, [isOpen, user])

    const handleChange = (name) => (value) => {
        setFormData((prev) => ({...prev, [name]: value}));
    };

    const getUserDataForChangePassword = useCallback(() => {
        const {oldPassword, newPassword} = formData;
        return {oldPassword, newPassword};
    }, [formData]);

    const saveUserData = useCallback(() => {
        changePasswordApi(getUserDataForChangePassword())
            .then((userUpdatedData) => {
                updateUserData(userUpdatedData);
                close();
                addNotification("passwordChanged", config.notificationLevels.success);
                setFormData({
                    ...formData,
                    oldPassword: "",
                    newPassword: "",
                });
            })
            .catch((e) => {
                if (e.response && e.response.data === "") {
                    addNotification('somethingWentWrong', config.notificationLevels.error);
                } else {
                    addNotification(e.response.data, config.notificationLevels.error);
                }
            })
    }, [
        formData,
        getUserDataForChangePassword,
        user,
        updateUserData,
        addNotification,
        close,
    ]);

    const {
        oldPassword,
        newPassword,
    } = formData;

    return (
        <Modal
               closeTimeoutMS={config.closeTimeoutMS}
               isOpen={isOpen}
               style={generalModalStyles.menuItemModalStyles}
               onRequestClose={onRequestClose}
               onCancel={close}
               onSubmit={saveUserData}
               title={<Translate text="security"/>}
               description={<Translate text="securityDescription"/>}
               headerIcon={<LockKeyholeIcon width={20} height={20} stroke="var(--ds-fg-secondary)"/>}
               headerSeparator
               footerSeparator
               footer={
                   <React.Fragment>
                       <SilverButton type="button" width="auto" height="40px" onClick={close}>
                           <Translate text="close"/>
                       </SilverButton>
                       <BlueButton type="button" width="auto" height="40px" onClick={saveUserData}>
                           <Translate text="save"/>
                       </BlueButton>
                   </React.Fragment>
               }
        >
            <div className="settings-modal-fields">
                <Input
                    label={<Translate text="oldPassword"/>}
                    controlled
                    onChange={(e) => handleChange("oldPassword")(e.target.value)}
                    value={oldPassword}
                    maxLength={20}
                    style={{height: "40px"}}
                />
                <Input
                    label={<Translate text="newPassword"/>}
                    controlled
                    onChange={(e) => handleChange("newPassword")(e.target.value)}
                    value={newPassword}
                    maxLength={20}
                    style={{height: "40px"}}
                />
            </div>
        </Modal>
    );
};

SecurityModal.propTypes = {
    user: PropTypes.object.isRequired,
    close: PropTypes.func.isRequired,
    addNotification: PropTypes.func.isRequired,
    updateUserData: PropTypes.func.isRequired,
    isOpen: PropTypes.bool,
    onRequestClose: PropTypes.func,
};

const mapStateToProps = (state) => ({
    user: state.user,
});

const mapDispatchToProps = {
    addNotification: addNotificationAction,
    updateUserData: updateUserDataAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(SecurityModal);



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/header/SecurityModal.jsx